export function badgeIdentity(notification) {
  try {
    const tag = String(notification?.tag || "");
    return tag.startsWith("dworks:") ? JSON.parse(decodeURIComponent(tag.slice(7))) : null;
  } catch { return null; }
}

export function nativeReadTarget(path, method) {
  const route = String(path || "").split("?")[0];
  if (method === "POST" && route === "/api/notifications/read-all") return { all:true };
  if (method === "POST" && route === "/api/broadcast-chat/read-all") return { broadcasts:true };
  let match = route.match(/^\/api\/notifications\/([^/]+)\/read$/);
  if (method === "PATCH" && match) return { notification_id:decodeURIComponent(match[1]) };
  match = route.match(/^\/api\/(?:buyer\/chats|vendor\/portal\/chats|factory\/portal\/chat\/threads)\/([^/]+)\/read$/);
  if (method === "POST" && match) return { thread_id:decodeURIComponent(match[1]) };
  match = route.match(/^\/api\/buyer\/(?:factory-chat\/threads|chats)\/([^/]+)$/);
  if (method === "GET" && match) return { thread_id:decodeURIComponent(match[1]), requireReadCount:true };
  return null;
}

export function readBadgeNotifications(snapshot, target, result) {
  if (!target || result?.ok !== true) return [];
  if (target.requireReadCount && !(Number(result?.notifications_marked_read) > 0 || result?.read_state_confirmed === true)) return [];
  const row = result?.notification;
  const rowData = row?.data && typeof row.data === "object" ? row.data : {};
  return snapshot.filter(notification => {
    if (notification.groupSummary) return false;
    const identity = badgeIdentity(notification);
    if (!identity) return false;
    if (target.all) return Array.isArray(result.read_notification_ids)
      ? result.read_notification_ids.includes(identity.notification_id) : true;
    if (target.broadcasts) return !!identity.broadcast_id;
    if (target.thread_id) return identity.thread_id === target.thread_id;
    if (identity.notification_id) return identity.notification_id === target.notification_id;
    return ["message_id", "shipment_id", "broadcast_id"].some(key => identity[key] && identity[key] === rowData[key]);
  });
}

export function prepareReadCleanup({snapshot, remove, isCurrent}, target) {
  if (!target) return () => {};
  // Start the device snapshot before the read request. Never clear notifications
  // which arrived while that request was in flight, or from a later login.
  let before;
  try { before = Promise.resolve(snapshot()).catch(() => []); }
  catch { before = Promise.resolve([]); }
  return result => {
    void before.then(rows => {
      if (!isCurrent()) return;
      const notifications = readBadgeNotifications(rows, target, result);
      if (notifications.length) return remove(notifications);
    }).catch(() => {});
  };
}
